<template>
  <div class="sec-textlist-base">
    <ul>
      <li v-for="(item, index) in items" :key="index">{{item.name}}<span v-if="items.length === index + 1 && itemsReceive.length > limitLen">他...</span></li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "SecTextList",
  data() {
    return {
      defLimitLen: 4
    }
  },
  props: {
    tagId: {
      type: Number,
      default(){
        return -1
      }
    },
    itemsReceive: {
      type: Array,
      default(){
        return []
      }
    },
    sectionData: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  computed: {
    items() {
      let rtnArr = []
      if(this.itemsReceive.length > this.limitLen) {
        for( let i = 0; i < this.limitLen; i++ ) {
          rtnArr.push(this.itemsReceive[i])
        }
      }else{
        rtnArr = this.itemsReceive
      }
      return rtnArr
    },
    limitLen(){
      if(!!this.sectionData && this.sectionData.itemLimit > 0) {
        return this.sectionData.itemLimit
      } else {
        return this.defLimitLen
      }
    }
  },
  methods: {
  }
}</script>

<style scoped lang="scss">
@import "../../../../sass/commons/commonVariables.scss";

.sec-textlist-base {
  padding: 0 20px;

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
    li {
      font-weight: normal;
      font-size: 13px;
      line-height: 1;
      color: $col_normal_font;
      padding-left: 18px;
      padding-top: 8px;
      padding-bottom: 8px;
      background: url('/static/img/icons/pink_triangle_A.svg') no-repeat left 8px;
      background-size: 9px 12px ;
      border-bottom: 1px dashed $col_temp_gray3;
      &:last-child {
        border-bottom: none;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/partials/SecTextList.vue